import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'blg-akaun-ts-lib-blg-akaun-ts-lib',
  template: `
    <p>
      blg-akaun-ts-lib works!
    </p>
  `,
  styles: []
})
export class BlgAkaunTsLibComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
